import { useId, useState } from 'react';
import { FileText } from 'lucide-react';

import { ttsApi } from '../../api/endpoints';
import styles from './TtsPage.module.css';

interface Props {
  onText: (text: string) => void;
  disabled: boolean;
}

export function DocxDrop({ onText, disabled }: Props) {
  const inputId = useId();
  const [dragging, setDragging] = useState(false);
  const [reading, setReading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const blocked = disabled || reading;

  const read = async (file: File | null) => {
    if (!file || blocked) return;
    setError(null);
    setReading(true);
    try {
      const result = await ttsApi.docxText(file);
      onText(result.text);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось прочитать файл.');
    } finally {
      setReading(false);
    }
  };

  return (
    <div className={styles.docxBlock}>
      <label
        htmlFor={inputId}
        className={`${styles.docxDrop} ${dragging ? styles.docxDropActive : ''} ${
          blocked ? styles.docxDropDisabled : ''
        }`}
        onDragOver={(event) => {
          event.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={(event) => {
          event.preventDefault();
          setDragging(false);
          void read(event.dataTransfer.files?.[0] ?? null);
        }}
      >
        <input
          id={inputId}
          type="file"
          accept=".docx"
          className={styles.hiddenInput}
          disabled={blocked}
          onChange={(event) => {
            const picked = event.target.files?.[0] ?? null;
            event.target.value = '';
            void read(picked);
          }}
        />
        <FileText size={14} strokeWidth={1.6} aria-hidden="true" />
        <span>{reading ? 'Читаем файл…' : 'Перетащите .docx или выберите файл'}</span>
      </label>
      {error && <div className={styles.docxError}>{error}</div>}
    </div>
  );
}
